import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { renderField } from '../../Utils/renderField/renderField';
import IconFloppyDisk from '../../../icons/floppy-disk';


const Form = (props) => {
    const {
        handleSubmit,
        initialValues = {}
    } = props;

    return (
        <form onSubmit={handleSubmit} className="d-flex flex-wrap">
            <div className="col-12 mb-3">
                <div className="mt-3">
                    <h6>PIN code</h6>
                    <Field
                        name="pin"
                        component={renderField}
                        placeholder='****'
                        type="password"
                        className='form-control'
                    />
                </div>

                <div className="mt-3">
                    <h6>Confirm PIN</h6>
                    <Field
                        name="pin2"
                        component={renderField}
                        placeholder='****'
                        type="password"
                        className='form-control'
                    />
                </div>
            </div>
            <div className="col-12 d-flex justify-content-end">
                <button type="submit" className="btn btn-primary d-flex justify-content-center align-items-center">
                    <div style={{height: '0.9rem' }} className="d-flex justify-content-center align-items-center mr-2">
                        <IconFloppyDisk className='h-100' />
                    </div>
                    SAVE
                </button>
            </div>
        </form>
    )
}

const DriverResetPasswordForm = reduxForm({
    form: 'driverResetPasswordForm',
    validate: (values) => {
        const errors = {};
        if (!values.pin) errors.pin = "Required Field";
        else if (values.pin.length !== 4) errors.pin = "Pin code needs to be 4 digits";
        if (!values.pin2) errors.pin2 = "Required Field";
        else if (values.pin2.length !== 4) errors.pin2 = "Pin code needs to be 4 digits";
        if (values.pin && values.pin2 && (values.pin != values.pin2))
            errors.pin2 = "The pin value doesn't match";
        return errors;
    }
})(Form);

export default DriverResetPasswordForm;
